module.exports = __webpack_public_path__ + "app/assets/images/man14-d3c154d44e4f2582a87781cf1d20dfdf.jpg";